import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { EquipmentSearchPage } from './equipment-search-page';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [EquipmentSearchPage],
    imports: [PagesModule, ComponentsModule],
    exports: [EquipmentSearchPage]
})
export class EquipmentSearchPageModule { }
